"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
require("./icon-selector.less");
var _iconLabel = _interopRequireDefault(require("./icon-label"));
var icons = _interopRequireWildcard(require("@nackle/origami-icons"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class IconSelector extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: props.currentIcon || '' // Set initial value from props
    };
  }
  componentDidUpdate(prevProps) {
    // Update state if currentIcon prop changes
    if (prevProps.currentIcon !== this.props.currentIcon) {
      this.setState({
        currentValue: this.props.currentIcon || ''
      });
    }
  }
  render() {
    const iconList = icons.default;
    const optionsArray = iconList.map(icon => {
      const newName = icon.name.replace(/([A-Z])/g, ' $1').trim();
      return {
        value: newName,
        label: /*#__PURE__*/_react.default.createElement(_iconLabel.default, {
          name: newName,
          title: newName === this.state.currentValue ? 'icon-image' : undefined // Only set title for the current value
        }, icon.component)
      };
    });
    const handleChange = value => {
      this.setState({
        currentValue: value
      }); // Update local state
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(value || ''); // Pass selected value to parent
      }
    };
    return /*#__PURE__*/_react.default.createElement(_antd.Select, {
      options: optionsArray,
      placeholder: "Chose an icon",
      onChange: handleChange,
      value: this.state.currentValue // Controlled value
      ,
      allowClear: true,
      showSearch: true,
      name: "icon-selector"
    });
  }
}
exports.default = IconSelector;
//# sourceMappingURL=icon-selector.js.map